<!-- Full-screen overlay container -->
<div
  class="file-viewer-overlay"
  [ngClass]="{ visible: visible, hidden: !visible }"
>
  <!-- White viewer panel -->
  <div class="file-viewer-panel">
    <!-- Fixed header with file name and close icon -->
    <div class="file-viewer-header">
      <div class="file-name">
        <h2>{{ (fileViewerService.currentFile$ | async)?.name || "File" }}</h2>
      </div>
      <div class="close-button">
        <dx-button
          icon="close"
          type="default"
          (onClick)="closeViewer()"
        ></dx-button>
      </div>
    </div>

    <!-- Main content area -->
    <div class="file-viewer-body">
      <!-- Loading placeholder bound to service.loading$ -->
      <div
        *ngIf="(fileViewerService.loadingState$ | async)?.isLoading"
        class="loading-container"
      >
        <div class="loading-text">
          {{
            (fileViewerService.loadingState$ | async)?.loadingText ||
              "Loading..."
          }}
        </div>
      </div>

      <!-- File content bound to service state -->
      <div
        class="file-content"
        *ngIf="!(fileViewerService.loadingState$ | async)?.isLoading"
      >
        <!-- Image files -->
        <img
          *ngIf="(fileViewerService.currentFile$ | async)?.type === 'image'"
          [src]="
            $safeNavigationMigration((fileViewerService.currentFile$ | async)?.blobUrl) | safeResourceURL
          "
          class="file-image"
          (error)="handleFileError()"
        />

        <!-- PDF files -->
        <embed
          *ngIf="(fileViewerService.currentFile$ | async)?.type === 'pdf'"
          [src]="
            $safeNavigationMigration((fileViewerService.currentFile$ | async)?.blobUrl) | safeResourceURL
          "
          type="application/pdf"
          width="100%"
          height="100%"
          class="file-pdf"
          (error)="handleFileError()"
          (load)="handlePDFLoaded()"
        />

        <!-- General document files -->
        <object
          *ngIf="
            (fileViewerService.currentFile$ | async)?.type === 'document' ||
            (fileViewerService.currentFile$ | async)?.type === 'general'
          "
          [data]="
            $safeNavigationMigration((fileViewerService.currentFile$ | async)?.blobUrl) | safeResourceURL
          "
          [type]="$safeNavigationMigration((fileViewerService.currentFile$ | async)?.mimeType)"
          width="100%"
          height="100%"
          class="file-document"
        >
          <p>
            Unable to display this file type.
            <a
              [href]="$safeNavigationMigration((fileViewerService.currentFile$ | async)?.blobUrl)"
              download="{{ (fileViewerService.currentFile$ | async)?.name }}"
              >Download file</a
            >
          </p>
        </object>

        <!-- Video files -->
        <video
          *ngIf="(fileViewerService.currentFile$ | async)?.type === 'video'"
          [src]="
            $safeNavigationMigration((fileViewerService.currentFile$ | async)?.blobUrl) | safeResourceURL
          "
          controls
          width="100%"
          height="100%"
          class="file-video"
        ></video>
      </div>
    </div>
  </div>
</div>
